import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { ButtonModule } from 'primeng/button'
import { MessageModule } from 'primeng/message'

@Component({
    selector: 'fm-email-verification-banner',
    standalone: true,
    imports: [ButtonModule, FontAwesomeModule, MessageModule],
    templateUrl: './email-verification-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailVerificationBannerComponent {
    @Input() email = ''
    @Input() isSent = false
    @Input() isResendDisabled = false
    @Output() openVerification = new EventEmitter<void>()
    @Output() resendVerification = new EventEmitter<void>()

    readonly faInfoCircle = faInfoCircle

    onResendVerification(event: MouseEvent): void {
        if (this.isResendDisabled) {
            event.preventDefault()
            return
        }

        this.resendVerification.emit()
    }
}
